<template>

    <ui-view class="view-sections">

        <ui-heading title="Vakken" icon="magicon-tiles">
            <ui-button
                color="positive"
                icon="magicon-plus"
                route="section-add"
                v-if="$can('MUTATE_SECTIONS')">Vak toevoegen</ui-button>
            <ui-searchbar v-model="search"/>
        </ui-heading>

        <ui-table-panel
            clickable
            v-spinner="loading"
            :placeholder="sections && !sections.items.length"
            :total="$safe('sections.totalCount')"
            :visible="paging.limit"
            @page="switchPage">
            <ui-table-header>
                <ui-th weight="2" field="name" v-model="sort">Naam</ui-th>
                <ui-th weight="1" field="parcelName" v-model="sort">In perceel</ui-th>
                <ui-th weight="1">Alias</ui-th>
                <ui-th weight="1" field="size" v-model="sort">Oppervlakte</ui-th>
                <ui-th weight="2" field="createdAt" v-model="sort">Datum aangemaakt</ui-th>
                <ui-th weight="1"/>
            </ui-table-header>
            <ui-tr v-for="section in $safe('sections.items')" :key="section.id" click="view">
                <td>{{ section.name }}</td>
                <td>{{ $safe(section, 'parcel.parcelLocation.name') }} {{ $safe(section, 'parcel.parcelLocation.number') }}</td>
                <td>{{ $safe(section, 'parcel.alias') | empty }}</td>
                <td>{{ section.size | number }} ha</td>
                <td>{{ section.createdAt | date("LL") }}</td>
                <td class="actions" @click.stop>
                    <ui-link
                        icon="entypo-eye"
                        v-tooltip="'Bekijken'"
                        action="view"
                        :to="{ name: 'section-detail', params: { id: section.id }}" />
                    <ui-link
                        icon="magicon-edit"
                        v-tooltip="'Wijzigen'"
                        :to="{ name: 'section-edit', params: { id: section.id }}"
                        v-if="$can('MUTATE_SECTIONS')" />
                    <ui-link
                        icon="magicon-trash"
                        v-tooltip="'Verwijderen'"
                        @click="deleteSection(section.id)"
                        v-if="$can('MUTATE_SECTIONS')" />
                </td>
            </ui-tr>
        </ui-table-panel>

    </ui-view>

</template>

<script>

import Vue from 'vue';
import Component from 'vue-class-component';

import pagingMixin from 'js-core/js/mixins/paging';
import createQuery from 'js-core/js/apollo/queries/createQuery';

import AllSectionsQuery from 'gql/queries/Sections/AllSections.gql';

import SectionMutations from 'app/mutations/SectionMutations';

@Component({

    name: 'Sections',
    mixins: [pagingMixin],
    apollo: {
        sections: createQuery(AllSectionsQuery, {

            variables(){

                return {
                    offset: this.paging.offset,
                    limit: this.paging.limit,
                    search: this.search,
                    sortField: this.sort.field,
                    sortDirection: this.sort.direction
                };
            }
        })
    }
})
export default class Sections extends Vue
{
    loading = 0;

    search = this.$persist('search');
    sort = this.$persist('sort', {
        field: 'parcelName',
        direction: 'ASC'
    });

    breadcrumb(){

        return 'Vakken';
    }

    async deleteSection(id) {

        const { result, overlay } = await this.$alert.delete('Weet je zeker dat je dit vak wilt verwijderen?', true, {
            subtitle: 'Ook alle voorgaande acties zullen worden verwijderd!'
        });

        if(!result) {
            return;
        }

        try {

            await SectionMutations.delete(id);

            this.$toast.success('Het vak is succesvol verwijderd');
            this.$refetchQuery('sections');
        }
        catch(e) {

            this.logger.error(`Something went wrong while deleting section ${id}:`, e);
            this.$toast.error('Er is iets fout gegaan tijdens het verwijderen van het vak');
        }

        this.$overlay.close(overlay);
    }
}

</script>